@import "../../../globalStyles/commons";

:host {
  display: inline-block;
  transform: scale(0);
  top: 0;
  left: 0;
  position: absolute;
  pointer-events: none;
  transition: transform 0.1s ease-out 0s;
  z-index: v(--z-index-popover);

  --popover-content-shadow: none;

  /**
  * @prop --goat-dropdown-menu-max-height: Maximum height of the menu
 */
  --goat-dropdown-menu-max-height: 100%;

  min-width: 10rem;
  line-height: 0;
}


:host-context(goat-dropdown[open]) {
  pointer-events: auto;
  transform: scale(1);
}

.dropdown-content {
  --goat-menu-max-height: var(--goat-dropdown-menu-max-height);
  position: relative;
  width: 100%;
  filter: var(--popover-content-shadow, none);
  --goat-menu-shadow: none;
}

